import { normalizeFilters } from "../../../shared/lib/normalizeFilters";

export const timeEntryKeys = {
  all: ["time-entries"] as const,
  breaks: () => [...timeEntryKeys.all, "breaks"] as const,
  lists: () => [...timeEntryKeys.all, "list"] as const,
  list: (filters?: Record<string, unknown>) =>
    [...timeEntryKeys.lists(), normalizeFilters(filters)] as const,
  detail: (id: number) => [...timeEntryKeys.all, "detail", id] as const,
};
